import { action } from 'easy-peasy'

const DEFAULT_STATE = {
  date: null,
  startTime: null,
}

const countdownStore = {
  ...DEFAULT_STATE,
  setCountdownStartForToday: action((state, payload) => {
    state.startTime = payload.startTime
    state.date = payload.date
  }),
}

export default countdownStore
